export default __webpack_public_path__ + "imgs/beTogether01.8dcf415.jpeg";